<credentials-table type="ROUTER"></credentials-table>
